import React from 'react'
import { useTheme } from '@mui/material/styles'

import MultiSelectWithSearch from 'components/Shared/MultiSelectWithSearch'
import { AdminUITheme } from 'types/AdminUiThemeMui'
import { FilterItem } from 'types/FilterBuilder'
import { updateFilter } from 'redux/slices/FilterBuilder'
import { useAppDispatch, useAppSelector } from 'redux/Hook'

type Props = {
  item: FilterItem
  index: number
}

const FilterByHub = (props: Props) => {
  const { item, index } = props
  const dispatch = useAppDispatch()

  const hubs = useAppSelector((state) => state.hubs.data)

  const getSelectedHub = () => {
    if (item.value) {
      const selectedHubs = item.value.split(',').map((id: any) => {
        const name = getHubName(id)

        if (name) return { name, id }
      })

      // Remove undefined values, this can happen when a hub is deleted after it is assigned
      const refinedHubs = selectedHubs.filter((hub: HubType) => hub)

      return refinedHubs
    }

    return []
  }

  const { defaultOpen } = item

  const getHubName = (id: string) => {
    const filteredHub = hubs.find((hub) => hub.id == id)

    return filteredHub?.name
  }

  const handleChange = (value: Tags) => {
    const hubsString = value.map((hub) => hub.id).toString()
    dispatch(updateFilter({ item: { value: hubsString }, index }))
  }

  const isOptionEqualToValue = (
    option: { name: string },
    value: { name: string },
  ) => {
    return option.name === value.name
  }

  const theme: AdminUITheme = useTheme()

  return (
    <MultiSelectWithSearch
      style={theme.GenericTheme.dynamicFilterWrapperWidth}
      selectedValues={getSelectedHub()}
      options={hubs}
      isOptionEqualToValue={isOptionEqualToValue}
      handleOnChange={handleChange}
      defaultOpen={defaultOpen}
      optionKey="name"
      dataCyLabel="filter-by-hub"
      labelKey="filters.hub.label"
      placeholderKey="filters.search"
    />
  )
}

export default FilterByHub
